import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  AlertDialogProps,
  Button,
  Heading,
  Text,
  VStack,
} from '@chakra-ui/react';
import { useAbortAll } from '@rpldy/tus-uploady';
import React, { useRef } from 'react';

export type ConfirmLogoutOnUploadDialogProps = {
  confirmLogout: () => void;
} & Omit<AlertDialogProps, 'children' | 'leastDestructiveRef'>;

export const ConfirmLogoutOnUploadDialog: React.FC<
  ConfirmLogoutOnUploadDialogProps
> = ({ confirmLogout, onClose, ...rest }) => {
  const abortAll = useAbortAll();
  const leastDestructiveRef = useRef(null);
  return (
    <AlertDialog
      isCentered
      onClose={onClose}
      leastDestructiveRef={leastDestructiveRef}
      {...rest}
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader pr={4}>
            <Heading size="md" as="h2" children={'Laufende Uploads'} />
          </AlertDialogHeader>
          <AlertDialogBody>
            <Text>{'Du hast noch laufende Uploads'}</Text>
          </AlertDialogBody>
          <AlertDialogFooter px={4}>
            <VStack minH="5.5rem" w="full">
              <Button
                width={'full'}
                children={'Uploads verwerfen'}
                onClick={() => {
                  abortAll();
                  console.log(abortAll());
                  confirmLogout();
                }}
              />
              <Button
                variant="ghost"
                width={'full'}
                children={'Hochladen fortführen'}
                onClick={onClose}
                ref={leastDestructiveRef}
              />
            </VStack>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};
